import React, {useState, useEffect, useContext} from 'react';
import {ConfigContext} from './ConfigContextProvider';
import {LocaleContext} from './LocaleContextProvider';

export const AuthenticationContext = React.createContext();

const AuthenticationContextProvider = props => {
  const [userOptions, setUserOptions] = useState(null);
  const [navigation, setNavigation] = useState(null);
  const {locale} = useContext(LocaleContext);
  
  const {SETUP_URL} = useContext(ConfigContext);
  const {USEROPTIONS_URL} = useContext(ConfigContext);
  const {MODE} = useContext(ConfigContext);
  const {APPID} = useContext(ConfigContext);
  

    const store = {
      userOptions: userOptions,
      navigation: navigation
    }

    document.addEventListener('updateUserOption',  (e) => { 
        //console.log("logged", e);
        setUserOptions(e.detail)
        //console.log("...> test", e.detail)
        //setLoginIsOpen(true);
    }, false);

    // document.addEventListener('checkSession',  (e) => { 
    //     console.log("logged", e);
    //     setUserOptions(e.detail)
    //     //setLoginIsOpen(true);
    // }, false);

    const loadNavigation= (url) => {
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => {
            setNavigation(result)
          },
          (error) => {
          }
      )
    }

    useEffect(() => {

        console.log(USEROPTIONS_URL, MODE)
        const param= {  appid: APPID, lang: locale, ssid: localStorage.getItem('ssid')};

        let formData = new FormData();
        for(var i in param){
          formData.append(i,param[i]);
        }

        const options= {
          method: 'POST',
          body: formData
          // body: JSON.stringify(param),
          // headers: {
          //   'Content-Type': 'application/json'
          // }
        };
        
        fetch(USEROPTIONS_URL, (MODE=="dev") ? {} : options )
        .then(res => res.json())
        .then(
          (result) => {
             console.log(result.settings, "--> setting")
            setUserOptions(result.settings)
            loadNavigation(SETUP_URL)
            // if(!result.settings.navigation) {
            //   console.log(result, "-----> result")
            //   loadNavigation(SETUP_URL)
            // } else {
            //   console.log("---> set navigation")
            //   setNavigation(result.settings.navigation)
            // }
          },
          (error) => {
              console.log("--> error")
          }
        )
        }, []);

    return (
        <AuthenticationContext.Provider value={store}>
            {userOptions && navigation && props.children}
        </AuthenticationContext.Provider>
    );
};

export default AuthenticationContextProvider